// extracted by mini-css-extract-plugin
module.exports = {"productWidgetApp":"_1vJfb","horizontal":"_3eNS2","emptyState":"_3x92e"};